import { ServiceTypeModelType } from '@teinor/erp/types/company/config/serviceType'
import { ConnectedProps, connect } from 'react-redux'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import withLoading from '../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../utils/reducers'
import { GroupVatPayload } from '../../../../../utils/reducers/globals/groupVats'
import ModalCEServiceType from './ModalCEServiceType'
import TwinTable from '../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderString, EditRow } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'

interface ConfigServiceTypesProps extends ComponentWithPermissions { }

const ConfigServiceTypes: React.FC<ConfigServiceTypesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('serviceTypes', 'Tipos de servicio'),
        newText: t('newServiceType', 'Nuevo Tipo de Servicio'),
    }

    return (
        <BaseScreenTable TableComponent={TableServiceTypesConnect} CreateModalComponent={ModalCEServiceType} EditModalComponent={ModalCEServiceType} pageData={pageData} userPermissions={userPermissions} />
    )
}

type TableServiceTypesProps = TableComponentProps & ReduxTableServiceTypes & {}

const TableServiceTypes: React.FC<TableServiceTypesProps> = ({ userPermissions, setTableInstance, setOpened, groupVats }) => {
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<ServiceTypeModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 120,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'billing_code',
            dataKey: 'billing_code',
            label: t('billingCode', 'Código de facturación'),
            sortable: true,
            minWidth: 190,
        },
        {
            id: 'GroupVatId',
            dataKey: 'GroupVatId',
            label: t('groupVat', 'Grupo de impuestos'),
            customRender: (parameterValue) => <CustomRenderString value={groupVats?.[parameterValue]?.name || ''} />,
            sortable: true,
            minWidth: 180,
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
        },
    ]
    return (
        <TwinTable name='serviceTypes' columns={columns} getDataFrom='/api/app/config/serviceType/getAllServiceTypes' setTableInstance={setTableInstance} onRowClick={(_id, rowData) => setOpened({ type: 'edit', allRowData: rowData })} />
    )
}

const tableServiceTypesDispatch = {
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
}

export type ReduxTableServiceTypes = ConnectedProps<typeof tableServiceTypesConnect>
const mapTableServiceTypesConnector = (state: AllReduxPayloads) => ({ groupVats: state.groupVats })
const tableServiceTypesConnect = connect(mapTableServiceTypesConnector, tableServiceTypesDispatch)
const tableServiceTypesConnectLoading = withLoading(TableServiceTypes, [{ fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' }])
const TableServiceTypesConnect = tableServiceTypesConnect(tableServiceTypesConnectLoading)

export default ConfigServiceTypes